module.exports = __webpack_public_path__ + "fonts/8c60825.ttf";